import React, { useEffect, useState } from 'react'
import '../../assets/css/PrintReserveInfoComponent.css';
import { ReserveStatus } from './ReserveStatus';
import { GetByReserveId_Factor_Api } from '../../API/FactorApi';

export const PrintReserveInfoComponent = ({setLoading, showMessage, reserve, type = 'Reserve' }) => {
// =================================================================
    const [factor, setFactor] = useState();
    // =================================================================
    useEffect(() => {
        loadData();
    }, []);
    // =================================================================
    const loadData = async () => {
      const reserveId = reserve.id;
      if (reserveId)
      {
        setLoading(true);
        try {
            const data = await GetByReserveId_Factor_Api(reserveId);
            setLoading(false);
            if (data.messageStatus === "Successful") {
                setFactor(data.messageData.data);
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
      }
    }
    // =================================================================

  const primaryUser = (reserve.reserve_Users || []).find(x => x.isPrimary) || {};
  return (
     factor ?
    <div className="reserve-info-container">
      <table className="reserve-info-table">
        <thead>
          <tr>
            <td>
              <span className='bold'>شماره پذیرش : {reserve.trackingCode}</span>
            </td>
            <td>
              <span className='bold'>وضعیت پذیرش: </span>
              <span><ReserveStatus reserveStatus={reserve.reserveStatus} /></span>
            </td>
            <td>
              <span className='bold'>{reserve.objectInstance.title}</span>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div className='bold' style={{ display: 'inline-block' }}>تاریخ تنظیم  :</div>
              <span>{reserve.createDateShamsi}</span>
            </td>

            <td>
              <span className='bold'>تاریخ ورود: </span>
              <span>
                <span>{reserve.from_Shamsi_DayOfWeek}</span>
                <div style={{ display: 'inline' }}>{reserve.from_Shamsi}</div>
              </span>
            </td>

            <td>
              <span className='bold'>تاریخ خروج: </span>
              <span>{reserve.to_Shamsi_DayOfWeek}</span>
              <div style={{ display: 'inline' }}>{reserve.to_Shamsi}</div>
            </td>
          </tr>

          <tr>
            <td><span className='bold'>نام و نام خانوادگی : </span> <span>{reserve.fullName}</span></td>
            <td><span className='bold'>شماره همراه: </span> <span>{reserve.mobile}</span></td>
            <td><span className='bold'>کد ملی: </span> <span>{primaryUser?.nationalCode}</span></td>
          </tr>

          <tr>
            {/* <td><span className='bold'>مدت: </span> <span>{daysBetweenShamsi(reserve.from_Shamsi, reserve.to_Shamsi)} شب</span></td> */}
            <td><span className='bold'>مدت: </span> <span>{factor.nightCount} شب</span></td> 
            <td><span className='bold'>تعداد نفرات: </span> <span>{reserve.reserve_Users.length}</span></td>

            {type?.toLowerCase() === 'food' ? (
              // اگر بخواهی سلول خالی نمایش داده نشود می‌توان اینجا null بازگرداند
              <td />
            ) : (
              <td>
                <span className='bold'>مبلغ کل (ریال): </span>
                <span>{factor.payablPrice.toLocaleString()}</span>
              </td>
            )}
          </tr>
        </tbody>
      </table>
    </div>    
    : <></>
  );
};